module.exports = __webpack_public_path__ + "img/1485109237.88dd3c65.jpg";